var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveWithBackgroundIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 28C15 29.1 15.9 30 17 30H25C26.1 30 27 29.1 27 28V18C27 16.9 26.1 16 25 16H17C15.9 16 15 16.9 15 18V28ZM18 18H24C24.55 18 25 18.45 25 19V27C25 27.55 24.55 28 24 28H18C17.45 28 17 27.55 17 27V19C17 18.45 17.45 18 18 18ZM24.5 13L23.79 12.29C23.61 12.11 23.35 12 23.09 12H18.91C18.65 12 18.39 12.11 18.21 12.29L17.5 13H15C14.45 13 14 13.45 14 14C14 14.55 14.45 15 15 15H27C27.55 15 28 14.55 28 14C28 13.45 27.55 13 27 13H24.5Z",
    fill: "#474342"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveWithBackgroundIcon);
export default __webpack_public_path__ + "static/media/remove-with-background-icon.2041736213bc5aa6ca1d60c9f864908c.svg";
export { ForwardRef as ReactComponent };